import React, { useState, useEffect } from "react";
import Information from "../shared/Information";
import { useAuth } from "../../firebase/AuthProvider";
import {
  AchievementNotification as AchievementNotificationType,
  getAchievementNotification,
  markAchievementNotificationAsRead,
} from "../../firebase/achievements";
import { useTranslation } from "react-i18next";

export default function AchievementNotification() {
  const { user } = useAuth();
  const { t } = useTranslation();
  const [showNotification, setShowNotification] = useState<boolean>(true);
  const [
    achievementNotification,
    setAchievementNotification,
  ] = useState<AchievementNotificationType | null>(null);

  useEffect(() => {
    if (!user) return;

    const unsubscribe = getAchievementNotification(
      user.id,
      setAchievementNotification
    );
    return () => unsubscribe();
  }, [user]);

  async function dismissNotification() {
    setShowNotification(false);
    if (!user) return;
    await markAchievementNotificationAsRead(user.id);
  }

  if (!showNotification || !achievementNotification) return null;

  return (
    <Information
      title={t("achievements.notification_title")}
      text={t("achievements.notification_" + achievementNotification.name)}
      handleOk={dismissNotification}
    />
  );
}
